import type { RouteObject } from 'react-router'
import { App } from './App'
import { RouteError } from './components/RouteError'
import { AuthProvider } from './lib/auth'

/** A data router (one catch-all route; App keeps its <Routes>), which is what
 *  lets a page ask to be warned before navigating away with unsaved edits
 *  (react-router's useBlocker). The declarative router could not. */
export const routes: RouteObject[] = [
  { path: '*', element: <AuthProvider><App /></AuthProvider>, errorElement: <RouteError /> },
]
